import Http from "../services/http";

import { ApiRoutes } from "../common/apiRoutes";

const getNotificationAPI = (page: any, limit: any) => Http.get(`notification/admin-notifications?page=${page}&limit=${limit}`);
const getNotificationManagementAPI = ({ search, page, limit, user_type,sortBy,sortDirection }: any) => Http.get(`${ApiRoutes.notification}?search=${search}&page=${page}&limit=${limit}&user_type=${user_type}&sort_by=${sortBy}&sort_direction=${sortDirection}`);
const getNotificationByIdAPI = (id: any) => Http.get(`${ApiRoutes.getnotification}/${id}`);
const createNotificationManagementAPI = (data: any) => Http.post(ApiRoutes.notification, data);

export {
  getNotificationAPI,
  getNotificationManagementAPI,
  getNotificationByIdAPI,
  createNotificationManagementAPI,
}